'use strict';
var $ = require('../internals/export');
var expm1 = require('../internals/math-expm1');

// `Math.expm1` method
// https://tc39.es/ecma262/#sec-math.expm1
// eslint-disable-next-line es/no-math-expm1 -- required for testing
$({ target: 'Math', stat: true, forced: expm1 !== Math.expm1 }, { expm1: expm1 });



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.math.expm1.js
// module id = 765
// module chunks = 0